import dynamic from 'next/dynamic';
import { useEffect, useState } from 'react';
import { twJoin } from 'tailwind-merge';

import Box from 'shopper/components/Box';

import Layout from 'components/Layout';
import HeadWithNoIndexAndNoFollow from 'components/Seo/HeadWithNoIndexAndNoFollow';
import TabNav from 'components/SuggestNewItem/TabNav';

import useMediaQuery from 'hooks/useMediaQuery';

import { sendEvent } from 'lib/gtag';
import { scrollToTop } from 'lib/utils';

import SuggestNewCouponForm from './Form';
import Heading from './Heading';
import Sidebar from './Sidebar';

const SuccessMessage = dynamic(() => import('./SuccessMessage'), {
  ssr: false,
});

const GA_EVENT_CATEGORY = 'suggest_coupon';

const SuggestNewCouponPage = () => {
  const { isMd } = useMediaQuery();
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);

  useEffect(() => {
    sendEvent({
      action: 'load_page',
      category: GA_EVENT_CATEGORY,
    });
  }, []);

  const onSubmitSuccess = () => {
    sendEvent({
      action: 'submit_success',
      category: GA_EVENT_CATEGORY,
    });

    scrollToTop();
    setShowSuccessMessage(true);
  };

  const onSuggestAnotherCouponButtonClick = () => {
    sendEvent({
      action: 'suggest_another',
      category: GA_EVENT_CATEGORY,
    });

    setShowSuccessMessage(false);
  };

  return (
    <>
      <HeadWithNoIndexAndNoFollow />
      <Layout
        headingComponent={
          !(!isMd && showSuccessMessage) ? (
            <Heading className={showSuccessMessage && 'hidden md:block'} />
          ) : null
        }
        sidebarComponent={
          <Sidebar
            className="hidden xl:flex"
            gaEventCategory={GA_EVENT_CATEGORY}
            isShowingSuccessMessage={showSuccessMessage}
          />
        }
        maxWidthOnMobileDevices
      >
        <Box
          className={twJoin('mb-[45px]', showSuccessMessage && 'md:mb-[77px]')}
        >
          {!showSuccessMessage ? (
            <>
              <TabNav gaEventCategory={GA_EVENT_CATEGORY} />
              <SuggestNewCouponForm
                className="mb-6"
                gaEventCategory={GA_EVENT_CATEGORY}
                onSubmitSuccess={onSubmitSuccess}
              />
            </>
          ) : (
            <SuccessMessage onClick={onSuggestAnotherCouponButtonClick} />
          )}
        </Box>
      </Layout>
    </>
  );
};

export default SuggestNewCouponPage;
